import { Link } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TechDocsIcon from '@material-ui/icons/Description';
import EventIcon from '@material-ui/icons/EventAvailable';
import GithubIcon from '@material-ui/icons/GitHub';
import HelpIcon from '@material-ui/icons/Help';
import { useEffect } from 'react';
import ErrorLogo from './bulbs.svg';
import { dtrum } from '@dynatrace/dtrum-api-types';

function refreshPage() {
  window.location.reload();
}
interface Window {
  dtrum: dtrum;
}

// Function to report error to Dynatrace
export function reportErrorToDynatrace(message: string) {
  (window as Window).dtrum?.reportError(message);
}

export function CustomBootErrorPage() {
  useEffect(() => {
    reportErrorToDynatrace('Oops error message from pdp');
  }, []);
  return (
    <Grid container spacing={2} style={{ maxWidth: '100%', padding: '2%' }}>
      <Grid item sm={12} md={6}>
        <Typography variant="h2" style={{ fontSize: '64px' }}>
          Oops.
        </Typography>
        <Typography variant="h2" style={{ fontSize: '64px' }}>
          We're experiencing a small glitch.
        </Typography>

        <Typography style={{ fontSize: '20px', paddingTop: '20px' }}>
          Please <Link onClick={refreshPage}>refresh</Link> your browser.
        </Typography>
        <Typography style={{ paddingTop: '25px', fontSize: '35px' }}>
          Support
        </Typography>
        <Typography>
          If you experience continued issues, please reach out to us in
          following ways.
        </Typography>
        <Grid container spacing={2} style={{ paddingTop: '20px' }}>
          <Grid item sm={12} md={5}>
            <Typography>
              <TechDocsIcon />
              <Link
                target="_blank"
                href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/"
                underline="none"
                style={{ paddingLeft: '5px' }}
              >
                Technical Documentation
              </Link>
            </Typography>
          </Grid>
          <Grid item sm={12} md={7}>
            <Typography>
              <GithubIcon />
              <Link
                target="_blank"
                href="https://github.com/principalinformationservices-emu/principal-developer-portal/issues"
                underline="none"
                style={{ paddingLeft: '5px' }}
              >
                Raise a GitHub issue
              </Link>
            </Typography>
          </Grid>
          <Grid item sm={12} md={5}>
            <Typography>
              <HelpIcon />
              <Link
                target="_blank"
                href="https://principal.service-now.com/esc?id=sc_cat_item&table=sc_cat_item&sys_id=cf39e5484711ed90291c87de536d4350"
                underline="none"
                style={{ paddingLeft: '5px' }}
              >
                Raise a ServiceNow ticket
              </Link>
            </Typography>
          </Grid>
          <Grid item sm={12} md={7}>
            <Typography>
              <EventIcon />
              <Link
                target="_blank"
                href="https://go.oncehub.com/PrincipalDeveloperPortal"
                underline="none"
                style={{ paddingLeft: '5px' }}
              >
                Setup a meeting to connect with the PDP team
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={12} md={6}>
        <img
          src={ErrorLogo}
          alt=""
          style={{ maxWidth: '100%', paddingTop: '90px' }}
        />
      </Grid>
    </Grid>
  );
}
